export default __webpack_public_path__ + "static/media/babykraken_logo.dbee596b.png";